/* The shape of the panel, before the panel exists.

   Bootstrap makes three ElevenLabs calls, so a cold start is not instant, and
   what used to be on screen for that second was nothing at all — an empty page
   is indistinguishable from a broken one. This draws the layout it is about to
   become: same three columns, same card rhythm. */

function Line({ w = "100%", h = 12 }: { w?: string; h?: number }) {
  return <div className="skel-line" style={{ width: w, height: h }} />;
}

function Card({ lines = 3, title = true }: { lines?: number; title?: boolean }) {
  return (
    <div className="card skel-card">
      {title && <Line w="38%" h={9} />}
      {Array.from({ length: lines }, (_, at) => (
        <Line key={at} w={at === lines - 1 ? "70%" : "100%"} />
      ))}
    </div>
  );
}

export function PanelSkeleton() {
  return (
    <div id="app" aria-busy="true" aria-label="Loading the panel">
      <header>
        <Line w="120px" h={16} />
        <span className="spacer" />
        <Line w="180px" h={16} />
      </header>
      <main className="two-up">
        <section className="middle">
          <Card lines={4} />
          <Card lines={5} />
        </section>
        <aside className="right">
          <Card lines={3} />
          <Card lines={3} />
        </aside>
      </main>
    </div>
  );
}

/** The operator console is one column of cards, so it gets its own shape. */
export function ConsoleSkeleton() {
  return (
    <main className="platform" aria-busy="true" aria-label="Loading the console">
      <Line w="200px" h={20} />
      <div style={{ height: 24 }} />
      <Card lines={2} />
      <Card lines={5} />
    </main>
  );
}
